// Every space on 1 private client space product, for an owner or admin at 2-step login, each with a
// link to Adam's view of it (/mentorship?space=<id>, or the product's own path). No board draws it. It shows on /mentorship when Adam opens it with no space
// picked; admin's People, a client's page and Today carry their own links (stage 5), and People's
// "1-2-1 spaces" card opens a new space.
import { useEffect, useState } from 'react'
import { Link } from '../../lib/router.jsx'
import * as f from '../../lib/format.js'
import { SITE } from '../../config/site.js'
import { COPY } from './copy.js'
import { firstName, spacePath } from './model.js'
import { loadSpaces } from './data.js'

export function useSpaces(productId) {
  const [s, set] = useState({ status: 'loading', spaces: [] })
  const reload = () => loadSpaces(productId)
    .then(spaces => set({ status: 'ready', spaces }))
    .catch(() => set(prev => (prev.status === 'ready' ? prev : { status: 'error', spaces: [] })))
  useEffect(() => { reload() }, [productId])
  return { ...s, reload }
}

export function SpaceList({ product, spaces, className = '' }) {
  if (spaces.status === 'loading') return <div className="ms-spaces" aria-busy="true" />
  if (spaces.status === 'error') return <p className="ms-spaces-none" role="alert">{COPY.failedH}. {COPY.failedLine(SITE.helpEmail)}</p>
  if (!spaces.spaces.length) return <p className="ms-spaces-none">{COPY.spacesNone}</p>
  return (
    <ul className={`ms-spaces ${className}`.trim()}>
      {spaces.spaces.map(s => {
        const name = s.client?.full_name || firstName(s.client) || ''
        return (
          <li key={s.id} className="ms-space">
            <span className="ms-space-text">
              <span className="ms-space-name">{name}</span>
              <span className="ms-space-meta">{s.ended_at ? COPY.spaceEnded(f.shortDate(s.ended_at)) : COPY.spaceOpenSince(f.shortDate(s.opened_at))}</span>
            </span>
            <Link to={spacePath(product, s.id)} className="ms-space-link">{COPY.openSpaceLink(firstName(s.client) || name)}</Link>
          </li>
        )
      })}
    </ul>
  )
}

// /mentorship in Adam's view with no space picked: the list to pick from
export function SpacePicker({ product }) {
  const spaces = useSpaces(product.id)
  return (
    <div className="ms">
      <header className="ms-head">
        <span className="ms-eyebrow">{COPY.spacesEyebrow}</span>
        <h1 className="ms-h1">{COPY.spacesH1}</h1>
      </header>
      <SpaceList product={product} spaces={spaces} />
    </div>
  )
}
